<!--
 * @Author: 陈绍斌 1748362428@qq.com
 * @Date: 2023-05-25 19:43:30
 * @LastEditors: 陈绍斌 1748362428@qq.com
 * @LastEditTime: 2023-07-20 14:17:10
 * @FilePath: \Vyung.Portal.Front\src\views\ProductService\components\BusinessBlueprint\LTCBusinessBlueprint.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="LTC-business-blueprint">
    <div class="blueprint-content col-lg-8 col-md-8 col-sm-8 col-12">
      <img :src="blueprintBackground" alt="" />
      <div
        style="position: absolute; top: 9%; left: 2.8%; font-weight: bold"
        class="title justify-content-start"
      >
        {{ $t("product.VyungLTC.business_blueprint.card01.title") }}
      </div>
      <div
        class="box-body-top d-flex justify-content-between position-absolute"
      >
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card01.text01") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card01.text02") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card01.text03") }}
        </div>
        <div class="width-md">
          {{ $t("product.VyungLTC.business_blueprint.card01.text04") }}
        </div>
        <div class="width-md">
          {{ $t("product.VyungLTC.business_blueprint.card01.text05") }}
        </div>
        <div class="width-md">
          {{ $t("product.VyungLTC.business_blueprint.card01.text06") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card01.text07") }}
        </div>
      </div>

      <div
        style="position: absolute; top: 24.5%; left: 3%; font-weight: bold"
        class="title justify-content-start"
      >
        {{ $t("product.VyungLTC.business_blueprint.card02.title") }}
      </div>
      <div
        class="box-body-center1 d-flex flex-column justify-content-between position-absolute"
      >
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card02.text01") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card02.text02") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card02.text03") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card02.text04") }}
        </div>
      </div>

      <div
        style="position: absolute; top: 24.5%; left: 17.3%; font-weight: bold"
        class="title justify-content-start"
      >
        {{ $t("product.VyungLTC.business_blueprint.card03.title") }}
      </div>
      <div
        class="box-body-center2 d-flex flex-column justify-content-between position-absolute"
      >
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card03.text01") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card03.text02") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card03.text03") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card03.text04") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card03.text05") }}
        </div>
      </div>
      <div
        style="position: absolute; top: 24.5%; left: 31.5%; font-weight: bold"
        class="title justify-content-start"
      >
        {{ $t("product.VyungLTC.business_blueprint.card04.title") }}
      </div>
      <div
        class="box-body-center2 d-flex flex-column justify-content-between position-absolute"
        style="left: 407px"
      >
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card04.text01") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card04.text02") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card04.text03") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card04.text04") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card04.text05") }}
        </div>
      </div>

      <div
        class="box-body-center2 d-flex flex-column justify-content-between position-absolute"
        style="left: 557px"
      >
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card04.text06") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card04.text07") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card04.text08") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card04.text09") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card04.text10") }}
        </div>
      </div>
      <div
        class="box-body-center2 d-flex flex-column justify-content-between position-absolute"
        style="left: 707px"
      >
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card04.text11") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card04.text12") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card04.text13") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card04.text14") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card04.text15") }}
        </div>
      </div>

      <div
        style="position: absolute; top: 24.5%; left: 69.4%; font-weight: bold"
        class="title justify-content-start"
      >
        {{ $t("product.VyungLTC.business_blueprint.card05.title") }}
      </div>
      <div
        class="box-body-center1 d-flex flex-column justify-content-between position-absolute"
        style="left: 900px"
      >
        <div class="width-md">
          {{ $t("product.VyungLTC.business_blueprint.card05.text01") }}
        </div>
        <div class="width-md">
          {{ $t("product.VyungLTC.business_blueprint.card05.text02") }}
        </div>
        <div class="width-md">
          {{ $t("product.VyungLTC.business_blueprint.card05.text03") }}
        </div>
        <div class="width-md">
          {{ $t("product.VyungLTC.business_blueprint.card05.text04") }}
        </div>
      </div>

      <div
        style="position: absolute; top: 65.2%; left: 2.8%; font-weight: bold"
        class="title justify-content-start"
      >
        {{ $t("product.VyungLTC.business_blueprint.card06.title") }}
      </div>
      <div
        class="box-body-foot d-flex justify-content-between position-absolute"
      >
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card06.text01") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card06.text02") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card06.text03") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card06.text04") }}
        </div>
      </div>

      <div
        style="position: absolute; top: 81%; left: 2.8%; font-weight: bold;width:144px"
        class="title justify-content-start"
      >
        {{ $t("product.VyungLTC.business_blueprint.card07.title") }}
      </div>
      <div
        class="box-body-foot d-flex justify-content-between position-absolute"
        style="bottom: 72px"
      >
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card07.text01") }}
        </div>
        <div class="width-sm">
          {{ $t("product.VyungLTC.business_blueprint.card07.text02") }}
        </div>
        <div class="width-sm_1">
          {{ $t("product.VyungLTC.business_blueprint.card07.text03") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card07.text04") }}
        </div>
      </div>

      <div
        style="position: absolute; top: 65.2%; left: 48.5%; font-weight: bold;width:160px"
        class="title justify-content-start"
      >
        {{ $t("product.VyungLTC.business_blueprint.card08.title") }}
      </div>
      <div
        class="box-body-foot1 d-flex justify-content-between align-content-between flex-wrap position-absolute"
      >
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card08.text01") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card08.text02") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card08.text03") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card08.text04") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card08.text05") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card08.text06") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card08.text07") }}
        </div>
      </div>

      <div
        style="position: absolute; top: 9%; left: 85%; font-weight: bold"
        class="title justify-content-start"
      >
        {{ $t("product.VyungLTC.business_blueprint.card09.title") }}
      </div>
      <div
        class="box-body-right d-flex flex-column justify-content-between position-absolute"
      >
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card09.text01") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card09.text02") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card09.text03") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card09.text04") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card09.text05") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card09.text06") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card09.text07") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card09.text08") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card09.text09") }}
        </div>
        <div>
          {{ $t("product.VyungLTC.business_blueprint.card09.text10") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LTCBlueprint",
  data () {
    return {
      blueprintBackground: require("@/assets/images/ProductService/VyungLTC/blueprint-background.png"),
    };
  },
};
</script>